<template>
	<router-link :to="userPage" class="user-widget">
		<v-row class="avatar row" dense>
			<v-col>
				<user-avatar :user="user" :size="64" />
			</v-col>
		</v-row>
		<v-row class="name row" dense>
			<v-col>
				<div v-if="overline" class="overline">{{ overline }}</div>
				{{ user.displayName }}
			</v-col>
		</v-row>
	</router-link>
</template>

<style lang="scss" scoped>
.user-widget {
	text-decoration: none;
	color: inherit;

	&:hover .name {
		text-decoration: underline;
	}
}

.row {
	text-align: center;
}

.name {
	font-size: 0.75rem;
	font-weight: 600;
	font-family: "Roboto";
}
</style>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		overline: {
			type: String,
			required: false,
			default: null,
		},
	},

	computed: {
		userPage() {
			return {
				name: "Live User",
				params: { userId: this.user.guid },
			};
		},
	},
};
</script>
